/*
 * @Date: 2025-04-02 16:01:12
 * @LastEditors: 'lidianbin' 'lidianbin@coocaa.com'
 * @LastEditTime: 2025-04-02 16:25:29
 * @FilePath: \ccms\packages\cms-engine\lib\index.js
 */
// import Vue from 'vue'
const cmsComponents = require('@ccms/cms-components')
import Parser from './parser/Index.vue' // 解析器容器处理
import render from './render/index' // 解析器渲染处理
import qnParser from './parser/qnParser.vue' // 问卷调查解析器
import './style/richTextEditor.css'
import './style/index.styl'

import './gather' // 埋点sdk
const install = function (Vue) {
  Vue.use(cmsComponents)
}



export {
  install,
  Parser,
  render,
  qnParser
}
export default {
  install,
  Parser,
  render,
  qnParser
}
